module.exports = ".MyCalendar {\r\n  text-align: center;\r\n}\r\n\r\n.rbc-calendar {\r\n  margin: 0px;\r\n}\r\n\r\n.rbc-toolbar {\r\n  margin: 0px;\r\n}\r\n"